var Handlebars = require("/home/jenkins/agent/workspace/hybrid-accsts-task-release/hybrid-accsts-jsclient/target/toolchain/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"header\">\n    <button class=\"btn btn-default pull-right refresh\"><i class=\"glyphicon glyphicon-refresh\"></i> Refresh</button>\n    <div class=\"title\">\n        <h1>Harvest / Export Activity Log</h1>\n    </div>\n</div>\n<div class=\"results\"></div>\n<div class=\"footer\">\n\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./app/lib/hex/lib/resultslayout/templates/layout.hbs
// module id = 1439
// module chunks = 0